import { profileKey } from '@staffedupusa/shared-components';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useQuery } from 'react-query';

import {
  availableSlotsKey,
  avaliableBlocksRoute,
} from '@features/applicant';
import axiosInstance from '@server/axiosInstance';

type useGetAvaliableSlotsProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
  inviteId?: number | null;
  jobListingId?: number | string| null;
};

export const useGetAvaliableSlots = ({
  inviteId,
  jobListingId,
  setErrorText
}: useGetAvaliableSlotsProps) => {
  const { data: avaliableBlocks, isLoading: isAvaliableBlocksLoading, } = useQuery({
    queryKey: [availableSlotsKey, inviteId],
    queryFn: () => {
      const params = new URLSearchParams();

      params.append('block_invite_id', String(inviteId));
      jobListingId && params.append('job_listing_id', String(jobListingId));

      return axiosInstance
        .get(`${avaliableBlocksRoute}`, { params })
        .then((res) => res.data);
    },
    enabled: Boolean(inviteId),
  });
  return {
    avaliableBlocks,
    isAvaliableBlocksLoading,
  };
};

